// Scoped to the open patient's window. Both pending and completed reads are
// reused; failed requests can be retried and refreshes invalidate the scope.
export function createVisitRequestCache() {
    const requests = new Map();
    return {
        get(key, fetch) {
            if (!requests.has(key)) {
                const request = fetch().catch((error) => {
                    if (requests.get(key) === request) requests.delete(key);
                    throw error;
                });
                requests.set(key, request);
            }
            return requests.get(key);
        },
        clear() { requests.clear(); }
    };
}
